export const handleSave = async (
  type,
  args,
  context,
  { onSuccess, onError }
) => {
  try {
    let saveData = null;

    switch (type) {
      case "detailPL": {
        const [states, data] = args;
        const { details } = states;

        saveData = {
          tc_id: details.tc_id,
          financialYearEnd: details.financialYearEnd,
          financialYearStart: details.financialYearStart,
          yearOfAssessment: details.yearOfAssessment,
          revenue: data.revenue,
          costOfSale: data.costOfSale,
          Expenses: data.Expenses,
          otherIncome: data.otherIncome,
          flipSignMode: data.flipSignMode,
          comments: data.comments,
          reviewNote: data.reviewNote,
          netProfitBeforeTax: data.netProfitBeforeTax,
          doc: data.doc,
        };

        await context.updateDetailsPL(saveData);
        break;
      }
      case "mainComputationData": {
        const [states, data] = args;
        const { details } = states;

        saveData = {
          tc_id: details.tc_id,
          "Tax Adjustments": data["Tax Adjustments"],
          "Tax adjustment (separate sourced income)":
            data["Tax adjustment (separate sourced income)"],
          "Tax adjustment (balancing charge)":
            data["Tax adjustment (balancing charge)"],
          "Further deduction s14n": data["Further deduction s14n"],
          "Further deduction other": data["Further deduction other"],
          "Current Year Capital Allowances":
            data["Current Year Capital Allowances"],
          "Unutilised Capital Allowances":
            data["Unutilised Capital Allowances"],
          "Unutilised Losses": data["Unutilised Losses"],
          "Unutilised Donations": data["Unutilised Donations"],
          "Other Source Income": data["Other Source Income"],
          "Current Year Donations": data["Current Year Donations"],
          "Current Year Investment Losses":
            data["Current Year Investment Losses"],
          "Partial Tax Exemption / Full Tax Exemption":
            data["Partial Tax Exemption / Full Tax Exemption"],
          "Corporate Income Tax Rebate": data["Corporate Income Tax Rebate"],
          "Tax Previously Assessed": data["Tax Previously Assessed"],
          isStartup: data["isStartup"],
          comments: data["comments"],
          reviewNote: data["reviewNote"],
          doc: data.doc,
        };

        await context.updateMainComputation(saveData);
        break;
      }
      case "Savy": {
        const [states, data] = args;

        saveData = {
          sch_id: data.scheduleId,
          scheduleType: "Savy",
          scheduleTitle: data.scheduleTitle,
          rows: data.rows,
          notes: data.notes,
          reviewNotes: data.reviewNotes,
          totalAdjustment: data.totalAdjustment,
        };

        await context.updatePLSchedule(saveData);
        break;
      }
      case "Partial Breakdown": {
        const [states, data] = args;
        const { company } = states;

        saveData = {
          sch_id: data.scheduleId,
          scheduleType: "PartialBreakdown",
          scheduleTitle: data.scheduleTitle,
          rows: data.rows,
          notes: data.notes,
          reviewNotes: data.reviewNotes,
          totalAdjustment: data.totalAdjustment,
        };

        await context.updatePLSchedule(saveData);
        break;
      }
      case "Full Breakdown": {
        const [states, data] = args;
        const { company } = states;

        saveData = {
          sch_id: data.scheduleId,
          scheduleType: "FullBreakdown",
          scheduleTitle: data.scheduleTitle,
          rows: data.rows,
          notes: data.notes,
          reviewNotes: data.reviewNotes,
          totalAdjustment: data.totalAdjustment,
        };

        await context.updatePLSchedule(saveData);
        break;
      }
      case "FAAdditions": {
        const [states, data] = args;

        if (!data) throw Error("Unexpected error: unsaved data is empty.");
        saveData = {
          sch_id: data.sch_id,
          scheduleType: data.scheduleType,
          dataRows: data.dataRows,
          otherSourceRows: data.otherSourceRows,
          hirePurchaseSummary: data.hirePurchaseSummary,
          faAdditionsSummary: data.faAdditionsSummary,
          totalRenovation: data.totalRenovation,
          totalRevenue: data.totalRevenue,
          doc: data.doc,
          notes: data.notes,
          reviewNotes: data.reviewNotes,
        };

        await context.updateCASchedule(saveData);
        break;
      }
      case "FARegister": {
        const [, data] = args;

        if (!data) throw Error("Unexpected error: unsaved data is empty.");
        saveData = {
          sch_id: data.sch_id,
          scheduleType: data.scheduleType,
          dataRows: data.dataRows,
          summaries: data.summaries,
          doc: data.doc,
          notes: data.notes,
          reviewNotes: data.reviewNotes,
        };

        await context.updateCASchedule(saveData);
        break;
      }
      case "caSettings": {
        const [data] = args;

        saveData = {
          caSettings: data.caSettings,
        };

        await context.updateCaSettings(saveData);
        break;
      }
      default:
        throw new Error("Invalid save type specified.");
    }

    onSuccess?.("Saved successful.");
    // context.resetData(type);
    return true; // Return true on success
  } catch (error) {
    console.error("Save failed:", error);
    onError?.(
      error.response?.data?.message || "An error occurred while saving."
    );
    return false; // Return false on failure
  }
};
